export class ApprovedUrl {
  id: number;
  url: string;
  title: string;
  description: string | null;
  is_active: boolean;
  /** Null on platform-wide (PSA) rows. Differs from the requested org when inherited. */
  organization_id: number | null;
  organization_name: string | null;

  constructor() {
    this.id = -1;
    this.url = "";
    this.title = "";
    this.description = null;
    this.is_active = true;
    this.organization_id = null;
    this.organization_name = null;
  }

  static fromJson(data: any): ApprovedUrl {
    const row = new ApprovedUrl();
    row.id = data?.id ?? -1;
    row.url = data?.url ?? "";
    row.title = data?.title ?? "";
    row.description = data?.description ?? null;
    row.is_active = data?.is_active ?? true;
    row.organization_id = data?.organization_id ?? null;
    row.organization_name = data?.organization_name ?? null;
    return row;
  }

  static fromJsonList(data: any[]): ApprovedUrl[] {
    return (data ?? []).map(ApprovedUrl.fromJson);
  }
}
